// import "@babel/polyfill";

import $ from "jquery";

// import _ from 'lodash';

import LazyLoad from "vanilla-lazyload";

// SimpleShare
// import SimpleShare from './plugins/simpleshare/index';

// AOS
// import AOS from 'aos';
// import 'aos/dist/aos.css';

// vanilla-cookieconsent
// import cookieConsent from './plugins/cookie-consent';

// import isMobile from 'mobile-device-detect';

import "@splidejs/splide/css";
import Splide from "@splidejs/splide";

import "select2/dist/css/select2.min.css";
import select2 from "select2";

// import validate from 'jquery-validation';

import { layer } from "./plugins/layer/index.js";

import axios from "axios";

import Pjax from "pjax";

import validate from "jquery-validation";

// import 'intl-tel-input/build/css/intlTelInput.css';
// import intlTelInput from 'intl-tel-input';

// import './forms';

// import { Fancybox } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox.css";

import { cos, Bucket, Region } from "./plugins/cos.js";
import { tcVod } from "./plugins/vod.js";
import { createFileName, bytesToSize } from "./plugins/methods.js";
import ImageCropper from "./plugins/image-cropper/index.js";
import { showLayerLoading, hideLayerLoading } from "./plugins/layerLoading.js";
import Language from "./language.js";
const lang = new Language();

const langCode = $("#lang").val();

(function uploadImage() {
	if ($(".js-upload-img").length) {
		$(".js-upload-img").on("change", function (e) {
			const fileObj = e.target.files[0];
			console.log(fileObj);
			var fileObjUrl = window.URL.createObjectURL(fileObj);
			console.log(fileObjUrl);

			const coverBox = $("." + $(this).data("coverbox"));
			const inputName = $("input[name=" + $(this).data("inputname") + "]");

			$(this).val("");

			const imagecropper = new ImageCropper({
				imgurl: fileObjUrl,
				width: 720,
				height: 480,
				done: function (blob) {
					// console.log(blob);
					const myFile = new File([blob], "jpg", {
						type: blob.type,
					});
					// console.log(window.URL.createObjectURL(myFile));
					coverBox.css({
						"background-image": "url(" + window.URL.createObjectURL(myFile) + ")",
					});

					// console.log('done - cropper');

					const fileName = myFile.name;
					const fileType = myFile.type;
					const fileExtension = fileName.split(".").pop().toLowerCase();
					const newFileName = createFileName(24) + "." + fileExtension;
					showLayerLoading();
					cos.uploadFile(
						{
							Bucket: Bucket /* 填写自己的bucket，必须字段 */,
							Region: Region /* 存储桶所在地域，必须字段 */,
							Key: newFileName /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
							Body: myFile, // 上传文件对象
							SliceSize: 1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
							onProgress: function (progressData) {
								// console.log(JSON.stringify(progressData));
							},
						},
						function (err, data) {
							if (err) {
								// console.log('上传失败', err);
							} else {
								// console.log('上传成功');
								console.log(data);
								inputName.val(newFileName);
								// console.log(newFileName);
							}
							hideLayerLoading();
						}
					);
				},
			});
		});
	}

	if ($(".js-upload-wcover").length) {
		$(".js-upload-wcover").on("change", function (e) {
			const fileObj = e.target.files[0];
			console.log(fileObj);

			if (!["image/jpg", "image/jpeg", "image/bmp", "image/png"].includes(fileObj.type)) {
				layer.msg(lang.errorImageFormat);
				return false;
			}

			var fileObjUrl = window.URL.createObjectURL(fileObj);
			console.log(fileObjUrl);

			$(this).val("");
			const imagecropper = new ImageCropper({
				imgurl: fileObjUrl,
				width: 490,
				height: 325,
				done: function (blob) {
					// console.log(blob);
					const myFile = new File([blob], "jpg", {
						type: blob.type,
					});
					// console.log(window.URL.createObjectURL(myFile));
					$(".wcover-label").addClass("active");
					$(".wcover-label").css({
						"background-image": "url(" + window.URL.createObjectURL(myFile) + ")",
					});

					console.log("done - cropper");

					const fileName = myFile.name;
					const fileType = myFile.type;
					const fileExtension = fileName.split(".").pop().toLowerCase();
					const newFileName = createFileName(24) + "." + fileExtension;
					console.log(newFileName);
					showLayerLoading();
					cos.uploadFile(
						{
							Bucket: Bucket /* 填写自己的bucket，必须字段 */,
							Region: Region /* 存储桶所在地域，必须字段 */,
							Key: newFileName /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
							Body: myFile, // 上传文件对象
							SliceSize: 1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
							onProgress: function (progressData) {
								console.log(JSON.stringify(progressData));
							},
						},
						function (err, data) {
							if (err) {
								// console.log(err)
								console.log("上传失败", err);
							} else {
								console.log("上传成功");
								console.log(data);
								$("input[name=wcover_name]").val(newFileName);
								// console.log(newFileName);
							}
							hideLayerLoading();
						}
					);
				},
			});
		});
	}

	if ($(".js-upload-multiple-img").length) {
		const fileInput = document.getElementById("file");
		let fileList = [];

		const upConfig = {
			fileType: ["image/jpg", "image/jpeg", "image/bmp", "image/png"], //支持的图片格式
			fileSize: 1024 * 1024 * 5, //单张图片大小不得超过2M
			max: 10, //最多上传10张图片
		};

		$("#file").on("change", function () {
			let filesArr = fileInput.files;
			filesArr = Array.prototype.slice.call(filesArr);

			$(this).val("");

			for (let i = 0; i < filesArr.length; i++) {
				const imgUrl = window.URL.createObjectURL(filesArr[i]);
				const size = bytesToSize(filesArr[i].size);
				const datafileid = $(".file-item").length + 1;

				console.log(filesArr[i].type, "type");
				if (!upConfig.fileType.includes(filesArr[i].type)) {
					layer.msg(lang.errorImageFormat);
					return false;
				}

				if (filesArr[i].size > upConfig.fileSize) {
					layer.msg(lang.uploadFileSizeFive);
					return false;
				}

				if (datafileid > upConfig.max) {
					layer.msg(lang.uploadImageMax);
					return false;
				}

				if (fileList.length < upConfig.max) {
					fileList.push(filesArr[i]);

					const imageItem = document.createElement("div");
					imageItem.className = "file-item";

					imageItem.innerHTML =
						`<input class="file-item__name" type="hidden" name="images[]" value="">
					<div class="file-item__bg"></div>
					<svg class="file-item__loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
						<circle cx="50" cy="50" fill="none" stroke="#292726" stroke-width="5" r="20" stroke-dasharray="94.24777960769379 33.41592653589793">
							<animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
						</circle>
					</svg>
					<div class="file-item__close js-file-delete icon-close"></div><p class="file-item__size">` +
						size +
						`</p>`;

					const imageBox = document.querySelector(".js-upload-multiple-box");
					const imageItemBg = imageItem.querySelector(".file-item__bg");
					const imageItemLoading = imageItem.querySelector(".file-item__loading");
					const imageInput = imageItem.querySelector(".file-item__name");

					imageBox.appendChild(imageItem);

					const fileName = filesArr[i].name;
					const fileExtension = fileName.split(".").pop().toLowerCase();
					console.log(fileExtension);
					const newFileName = createFileName(24) + "." + fileExtension;
					cos.uploadFile(
						{
							Bucket: Bucket /* 填写自己的bucket，必须字段 */,
							Region: Region /* 存储桶所在地域，必须字段 */,
							Key: newFileName /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
							Body: filesArr[i], // 上传文件对象
							SliceSize: 1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
							onProgress: function (progressData) {
								console.log(JSON.stringify(progressData));
							},
						},
						function (err, data) {
							if (err) {
								// console.log('上传失败', err);
							} else {
								// console.log('上传成功');
								console.log(data);
								imageInput.value = newFileName;
								imageItemBg.style.backgroundImage = `url(//` + data.Location + `?imageMogr2/thumbnail/140x)`;
								imageItemLoading.remove();
							}
						}
					);
				} else {
					// layer.msg('上传图片不得超过2Mb，请重新选择。');
					layer.msg(lang.uploadImageMax);
					return false;
				}
			}
		});

		// 删除图片
		$(document).on("click", ".js-file-delete", function () {
			$(this).parents(".file-item").remove();
		});
	}

	if ($(".js-upload-pdf").length) {
		$(".js-upload-pdf").on("change", function (e) {
			const file = e.target.files[0];

			const input = $(this);
			console.log(file);

			$(this).val("");
			// 只选择PDF文件
			if (!file.type.match("application/pdf")) {
				const obj = document.getElementById("pdf1");
				layer.msg(lang.errorPdfFormat);
				obj.value = "";
				return false;
			}

			if (file.size > 10 * 1024 * 1024) {
				const obj = document.getElementById("pdf1");
				layer.msg(lang.uploadFileSizeTen);
				obj.value = "";
				return false;
			}

			const fileName = file.name;
			const fileType = file.type;
			const fileExtension = fileName.split(".").pop().toLowerCase();
			const newFileName = createFileName(16) + "." + fileExtension;

			$(".js-upload-pdf-loading").addClass("show");

			cos.uploadFile(
				{
					Bucket: Bucket /* 填写自己的bucket，必须字段 */,
					Region: Region /* 存储桶所在地域，必须字段 */,
					Key: newFileName /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
					Body: file, // 上传文件对象
					SliceSize: 1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
					onProgress: function (progressData) {
						console.log(JSON.stringify(progressData));
					},
				},
				function (err, data) {
					if (err) {
						// console.log('上传失败', err);
					} else {
						// console.log('上传成功');
						// console.log(data);
						$("input[name=pdf_cos]").val(newFileName);
						$("input[name=pdf_name]").val(fileName);
						$(".js-upload-pdf-label").html(fileName);
						$(".js-clear-pdf").show();
						$(".js-upload-pdf-loading").removeClass("show");
						// console.log(newFileName);
					}
				}
			);
		});

		$(".js-clear-pdf").on("click", function () {
			$(".js-upload-pdf-label").html(lang.selectFile);
			$(".js-clear-pdf").hide();
			$("input[name=pdf_cos]").val("");
			$("input[name=pdf_name]").val("");
		});
	}

	if ($(".js-upload-multiple-pdf").length) {
		console.log("js-upload-multiple-pdf");
		const pdfInput = document.getElementById("pdfs");

		let pdfList = [];

		const upConfig = {
			fileType: ["application/pdf"],
			fileSize: 1024 * 1024 * 10,
			max: 5,
		};

		$(".js-upload-multiple-pdf").on("change", function (e) {
			console.log("change");
			let filesArr = pdfInput.files;
			filesArr = Array.prototype.slice.call(filesArr);

			$(this).val("");

			for (let i = 0; i < filesArr.length; i++) {
				const imgUrl = window.URL.createObjectURL(filesArr[i]);
				const size = bytesToSize(filesArr[i].size);
				const datafileid = $(".pdfs-item").length + 1;

				if (filesArr[i].size > upConfig.fileSize) {
					layer.msg(lang.uploadFileSizeTen);
					return false;
				}

				if (datafileid > upConfig.max) {
					layer.msg(lang.uploadPdfMax);
					return false;
				}

				if (pdfList.length < upConfig.max) {
					console.log(filesArr[i]);
					pdfList.push(filesArr[i]);

					const fileName = filesArr[i].name;

					const pdfsItem = document.createElement("div");
					pdfsItem.className = "label-file-wrap pdfs-item";

					pdfsItem.innerHTML = `<input type="hidden" class="js-upload-pdfs-cos" name="pdfs_cos[]" value="">
					<input type="hidden" class="js-upload-pdfs-name" name="pdfs_name[]" value="">
					<span class="label-file-clear icon-close js-pdfs-delete"></span>
					<label class="label-work-video mt-20"></label>
					<span class="fi-video-loading js-upload-pdfs-loading" style="display: block;">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
							<circle cx="50" cy="50" fill="none" stroke="#292726" stroke-width="5" r="20" stroke-dasharray="94.24777960769379 33.41592653589793">
								<animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
							</circle>
						</svg>
					</span>`;

					const pdfsBox = document.querySelector(".js-upload-pdf-multiple-box");
					const pdfsItemLoading = pdfsItem.querySelector(".js-upload-pdfs-loading");
					const pdfsCos = pdfsItem.querySelector(".js-upload-pdfs-cos");
					const pdfsName = pdfsItem.querySelector(".js-upload-pdfs-name");
					const pdfsShowName = pdfsItem.querySelector(".label-work-video");

					pdfsBox.appendChild(pdfsItem);

					const fileExtension = fileName.split(".").pop().toLowerCase();
					// console.log(fileExtension);
					const newFileName = createFileName(24) + "." + fileExtension;

					cos.uploadFile(
						{
							Bucket: Bucket /* 填写自己的bucket，必须字段 */,
							Region: Region /* 存储桶所在地域，必须字段 */,
							Key: newFileName /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
							Body: filesArr[i], // 上传文件对象
							SliceSize: 1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
							onProgress: function (progressData) {
								// console.log(JSON.stringify(progressData));
							},
						},
						function (err, data) {
							if (err) {
								// console.log('上传失败', err);
							} else {
								// console.log('上传成功');
								// console.log(data);
								pdfsCos.value = newFileName;
								pdfsName.value = fileName;
								pdfsItemLoading.remove();
								pdfsShowName.innerHTML = fileName;
								// console.log(newFileName);
							}
						}
					);
				} else {
					// layer.msg('上传图片不得超过2Mb，请重新选择。');
					layer.msg(lang.uploadImageMax);
					return false;
				}
			}
		});
		console.log("delete");
		$(document).on("click", ".js-pdfs-delete", function () {
			console.log("delete");
			$(this).parents(".pdfs-item").remove();
		});
	}

	if ($(".js-upload-video").length) {
		$(".js-upload-video").on("change", function (e) {
			var file = e.target.files[0];

			var input = $(this);
			$(this).val("");
			// 只选择视频文件
			if (!file.type.match("video.mp4")) {
				layer.msg(lang.errorVideoFormat);
				return false;
			}

			if (file.size > 2048 * 1024 * 1024) {
				layer.msg(lang.uploadFileSize2G);
				return false;
			}

			const fileName = file.name;
			const fileType = file.type;
			const fileExtension = fileName.split(".").pop().toLowerCase();
			const newFileName = createFileName(16) + "." + fileExtension;
			$(".js-upload-video-loading").addClass("show");
			const uploader = tcVod.upload({
				mediaFile: file, // 媒体文件（视频或音频或图片），类型为 File
				mediaName: newFileName,
			});

			uploader.on("media_progress", function (info) {
				console.log(info.percent); // 进度
			});

			uploader
				.done()
				.then(function (doneResult) {
					console.log(doneResult);
					// console.log('上传成功');
					$("input[name=wvideo_url]").val(doneResult.video.url);
					$("input[name=wvideo_name]").val(fileName);
					$("input[name=fileId]").val(doneResult.fileId);
					$(".js-upload-video-box").html(fileName);
					$(".js-upload-video-clear").show();
					$(".js-upload-video-loading").removeClass("show");
					// console.log(newFileName);
				})
				.catch(function (err) {
					// deal with error
					// layer.msg('上传失败请刷新后重试');
				});
		});

		$(".js-upload-video-clear").on("click", function () {
			$("input[name=wvideo_url]").val("");
			$("input[name=wvideo_name]").val("");
			$("input[name=fileId]").val("");
			$(".js-upload-video-box").html(lang.selectVideo);
			$(".js-upload-video-clear").hide();
		});
	}
})();

(function vote() {
	const fixedNav = () => {
		const sTop = $(window).scrollTop();
		const headerH = $(".header").outerHeight();
		const nTop = $(".js-fixed-pnav-box").offset().top - headerH;
		if (sTop > nTop) {
			$(".js-fixed-pnav").addClass("fixed");
			$(".js-fixed-pnav").css({
				top: headerH + "px",
			});
		} else {
			$(".js-fixed-pnav").removeClass("fixed");
			$(".js-fixed-pnav").css({
				top: "auto",
			});
		}
	};
	if ($(".js-fixed-pnav").length) {
		$(window)
			.on("scroll", function () {
				fixedNav();
			})
			.trigger("scroll");
	}

	$(".js-confirm-voting").on("click", function () {
		console.log("confirm");
		layer.confirmVotingResult(function () {
			console.log("confirm - layer");
		});
	});

	$(".js-vw-vote").on("click", function () {
		layer.confirmVoteScore(function () {
			console.log("vote - layer");
		});
	});

	$(".js-show-imggrid").on("click", function () {
		$(".vw-body").toggleClass("show-imglist");
	});

	if ($(".splide-vwimg").length) {
		console.log("test");
		const splideVW = new Splide(".splide-vwimg", {
			type: "fade",
			pagination: false,
		}).mount();

		$(".js-vwimg-prev").on("click", function () {
			splideVW.go("<");
		});
		$(".js-vwimg-next").on("click", function () {
			splideVW.go(">");
		});

		const len = $(".list-vwimg > li").length;
		$(".js-vwimg-all").html(len < 10 ? "0" + len : len);

		splideVW.on("moved", function (newIndex, prevIndex, destIndex) {
			const now = newIndex + 1;
			$(".js-vwimg-now").html(now < 10 ? "0" + now : now);
		});
	}

	$(".js-show-vwintro").on("click", function () {
		$(".vw-body").toggleClass("show");
	});

	if ($(".js-select2").length) {
		// console.log('ttt');
		$(".js-select2").each(function (index, item) {
			const placeholder = $(item).attr("aria-placeholder");
			const islink = $(item).attr("data-url");
			// console.log(placeholder);
			$(item).select2({
				placeholder: placeholder,
				minimumResultsForSearch: Infinity,
			});
			$(item).on("select2:select", function (e) {
				// console.log('ttttt');
				// $(this).parents('form').submit();
				var data = e.params.data;
				console.log(data);
				if (islink) {
					location.href = data.id;
				}
			});
		});
	}

	$(document).on("click", ".js-lvmsg-submit", function () {
		// $('.layer-vmsg').remove();
	});

	if ($(".pvote-table").length) {
		let pjax = new Pjax({
			elements: ".js-pjax",
			selectors: [".js-pjax-list", ".js-pjax-nav"],
			scrollTo: false,
		});

		const url = $(".pvote-table").data("url");

		$(document).on("change", ".pvotet-checkbox", function () {
			const type = $(this).data("type");
			const id = $(this).data("id");

			const formData = new FormData();
			formData.append("type", type);
			formData.append("id", id);

			axios
				.post(url, formData)
				.then(function (res) {
					if (res.data.success) {
						console.log("success");
						pjax.loadUrl(window.location.href);
					} else {
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		});

		$(document).on("click", ".js-pvotet-msg", function () {
			const id = $(this).data("id");
			const msg = $(this).data("msg");
			console.log(msg);
			const url = $(this).data("url");
			const msgBox = document.createElement("div");
			msgBox.classList = "layer-vmsg-box";
			const temp = `<div class="layer-vmsg">
							<div class="layer-vmsg__bg js-lvmsg-close"></div>
							<div class="layer-vmsg__main bg-white">
								<span class="lvmsg-close js-lvmsg-close icon-close fz-14 black"></span>
								<form action="${url}" autocomplete="off" class="lvmsg-form">
									<input type="hidden" name="id" value="${id}">
									<div>
										<textarea class="lvmsg-textarea fz-16 black" name="msg" id="" rows="5" required>${msg}</textarea>
									</div>
									<div class="text-right mt-10">
										<button class="lvmsg-submit btn-submit js-lvmsg-submit fz-16 black bg-yellow">${lang.btnConfirm}</button>
									</div>
								</form>
							</div>
						</div>`;
			msgBox.innerHTML = temp;
			document.body.appendChild(msgBox);

			let isSubmit = true;
			const form = $(".lvmsg-form");
			const btnSubmit = msgBox.querySelector(".btn-submit");
			form.validate({
				submitHandler: function (form) {
					if (isSubmit) {
						isSubmit = false;
						const postURL = $(form).attr("action");
						const postData = $(form).serialize();

						axios
							.post(postURL, postData)
							.then(function (res) {
								// console.log(res);
								// console.log(langCode);
								let msg;
								if (langCode == "en") {
									msg = res.data.info;
								} else {
									msg = res.data.info_cn;
								}
								// console.log(msg, res.data.success);
								if (res.data.success) {
									$(".layer-vmsg-box").remove();
									layer.msg(msg, { time: 2000 }, function () {
										// location.reload();
										pjax.loadUrl(window.location.href);
									});
								} else {
									layer.msg(msg);
								}
								isSubmit = true;
							})
							.catch(function (err) {
								console.log(err);
								let msg;
								if (langCode == "en") {
									msg = res.data.info;
								} else {
									msg = res.data.info_cn;
								}
								layer.msg(msg);
								isSubmit = true;
							});
					}
				},
				rules: {
					msg: {
						required: false,
					},
				},
				messages: {
					msg: {
						required: lang.required,
					},
				},
			});
			btnSubmit.addEventListener("click", function () {
				form.submit();
			});
		});
		$(document).on("click", ".js-lvmsg-close", function () {
			$(".layer-vmsg-box").remove();
		});
	}

	if ($(".js-pjax-list-vote").length) {
		const localUrl = window.location.href;

		let pjax = new Pjax({
			elements: "form[data-pjax], .js-pjax",
			selectors: [".js-pjax-list-vote", ".js-pjax-nav"],
			scrollTo: false,
		});

		$(document).on("click", ".js-works-adopt", function (e) {
			e.preventDefault();
			const url = $(this).data("url");
			axios
				.post(url)
				.then(function (res) {
					// console.log(res);
					let msg;
					if (res.data.success) {
						pjax.loadUrl(localUrl);
						// pjax.reload();
					} else {
						msg = langCode == "en" ? res.data.info : res.data.info_cn;
						layer.msg(msg);
					}
				})
				.catch(function (err) {
					console.log(err);
				});
		});

		$(document).on("click", ".js-works-abstain", function (e) {
			e.preventDefault();
			const url = $(this).data("url");
			axios
				.post(url)
				.then(function (res) {
					// console.log(res);
					let msg;
					if (res.data.success) {
						pjax.loadUrl(localUrl);
						// pjax.reload();
					} else {
						msg = langCode == "en" ? res.data.info : res.data.info_cn;
						layer.msg(msg);
					}
				})
				.catch(function (err) {
					console.log(err);
				});
		});

		$(document).on("click", ".js-works-detele", function (e) {
			// console.log('delete');
			e.preventDefault();
			const url = $(this).data("url");
			layer.dialog(
				lang.sureToWithdraw,
				[lang.btnConfirm, lang.btnCancel],
				[
					function () {
						// console.log('yes');
						axios
							.post(url)
							.then(function (res) {
								console.log(res);
								let msg;
								if (res.data.success) {
									// layer.msg()
									pjax.loadUrl(localUrl);
									// pjax.reload();
								} else {
									msg = langCode == "en" ? res.data.info : res.data.info_cn;
									layer.msg(msg);
								}
							})
							.catch(function (err) {});
					},
					function () {
						console.log("no");
					},
				]
			);
		});

		$(document).on("click", ".js-works-collect", function (e) {
			e.preventDefault();
			const url = $(this).data("url");
			axios
				.post(url)
				.then(function (res) {
					// console.log(res);
					let msg;
					if (res.data.success) {
						pjax.loadUrl(localUrl);
					} else {
						msg = langCode == "en" ? res.data.info : res.data.info_cn;
						layer.msg(msg);
					}
				})
				.catch(function (err) {
					console.log(err);
				});
		});

		$(document).on("click", ".vote-item__view", function (e) {
			e.preventDefault();
			const url = $(this).data("url");
			axios
				.post(url)
				.then(function (res) {
					// console.log(res);
					let msg;
					if (res.data.success) {
						pjax.loadUrl(localUrl);
					} else {
						msg = langCode == "en" ? res.data.info : res.data.info_cn;
						layer.msg(msg);
					}
				})
				.catch(function (err) {
					console.log(err);
				});
		});

		$(document).on("click", ".js-vwh-viewon", function (e) {
			e.preventDefault();
			const url = $(this).data("url");
			axios
				.post(url)
				.then(function (res) {
					// console.log(res);
					let msg;
					if (res.data.success) {
						pjax.loadUrl(localUrl);
					} else {
						msg = langCode == "en" ? res.data.info : res.data.info_cn;
						layer.msg(msg);
					}
				})
				.catch(function (err) {
					console.log(err);
				});
		});

		// 获取当前页面的URL
		var urlParams = new URLSearchParams(window.location.search);

		// 获取名为 "s" 的参数的值
		var sValue = urlParams.get("s");

		console.log(sValue, "svalue");

		if (sValue !== null) {
			// $('body').scrollTop();
			$("html,body")
				.stop()
				.animate(
					{
						scrollTop: $("#" + sValue).offset().top - 240,
					},
					0
				);
		}
	}

	const calcVHeight = () => {
		const h = window.innerHeight - $(".header").outerHeight() - $(".vw-header").outerHeight() - $(".vw-footer").outerHeight();
		$(".vw-body").css({
			height: `${h}px`,
		});
	};
	if ($(".vw-body").length) {
		$(window)
			.on("resize", function () {
				calcVHeight();
			})
			.trigger("resize");
	}
})();
